"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRIMARY_STORY = exports.CURRENT_SELECTION = void 0;
var CURRENT_SELECTION = '.';
exports.CURRENT_SELECTION = CURRENT_SELECTION;
var PRIMARY_STORY = '^';
exports.PRIMARY_STORY = PRIMARY_STORY;